import React from 'react';
import { ReactComponent as SlackIcon } from '@elementary/common-ui/assets/16x16/slack.svg';
import { ReactComponent as TeamsIcon } from '@elementary/common-ui/assets/16x16/teams.svg';
import { AlertIntegrationType } from '@elementary/common-ui/services/gql/types';
import themeBase from '@elementary/common-ui/style/theme';
import { IntegrationType } from 'shared/types';
import multipleDestinationsRenderer from '../../shared/multipleDestinationsRenderer';
import { DialogTypes } from './types';
import { ALERT_INTEGRATION_TYPE_TO_INTEGRATION_TYPE } from './constants';

export const messagingIconMap: Record<string, React.ReactNode> = {
  SLACK: <SlackIcon />,
  MICROSOFT_TEAMS: <TeamsIcon />,
};

export type MessagingIntegrationDetails = {
  type: AlertIntegrationType;
  name: string;
  usageText?: string;
};

export type MessagingMultipleDestinationsProps = {
  messagingIntegrations: MessagingIntegrationDetails[];
  setSelectedMessagingType: (type: AlertIntegrationType | null) => void;
  setDialog: (dialog: DialogTypes) => void;
  onDisconnect: (integrationType: IntegrationType) => void;
};

const MessagingMultipleDestinations = ({
  messagingIntegrations,
  setSelectedMessagingType,
  setDialog,
  onDisconnect,
}: MessagingMultipleDestinationsProps): React.ReactNode => {
  const handleChange = (method: string, integrationId: string) => {
    const integration = messagingIntegrations.find(
      (i) => i.type === integrationId,
    );
    if (!integration) return;

    if (method === 'edit') {
      setSelectedMessagingType(integration.type);
      setDialog('notification');
    } else if (method === 'disconnect') {
      onDisconnect(
        ALERT_INTEGRATION_TYPE_TO_INTEGRATION_TYPE[integration.type],
      );
    }
  };

  return multipleDestinationsRenderer({
    integrations: messagingIntegrations.map((messagingIntegration) => ({
      id: messagingIntegration.type,
      icon: messagingIconMap[messagingIntegration.type],
      name: messagingIntegration.name,
      status: 'connected',
      usageText: messagingIntegration.usageText,
    })),
    onChange: handleChange,
    options: [
      { value: 'edit', label: 'Edit' },
      {
        value: 'disconnect',
        label: 'Disconnect',
        color: themeBase.palette.common.red2,
      },
    ],
  });
};

export default MessagingMultipleDestinations;
